import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms/src/model";
import {FormBuilder} from "@angular/forms";
import {
  CategorieFormulaireDto,
  IAuditWebServiceClient,
  RechercheModeleDto,
  ICategorieFormulaireWebServiceClient
} from "app/common/resources/resources";
import * as lodash from "lodash";
import {Subscription} from "rxjs";
import {FiltreItem} from "@common/components/vos-filtres/filtre-item";
import { UserStore } from '@digicerba/common';

@Component({
  selector: 'filtres',
  templateUrl: './filtres.component.html',
})
export class FiltresComponent implements OnInit {

  filterForm: FormGroup;
  categories: Array<CategorieFormulaireDto>;
  subscr: Subscription;
  emptyCategorie: CategorieFormulaireDto = {id: -1, libelle: 'Sans catégorie'};

  @Output() onFiltering = new EventEmitter<RechercheModeleDto>();
  filtres = new Array<FiltreItem>();

  constructor(fb: FormBuilder, private categorieFormulaireWebService: ICategorieFormulaireWebServiceClient, private userStore: UserStore, private auditWebServiceClient: IAuditWebServiceClient) {

    this.filterForm = fb.group({
      modele: null,
      categorie: null,
    });

    this.subscr = this.filterForm.valueChanges.debounceTime(500).subscribe(() => {
      this.submit();
    })
  }

  ngOnInit() {
    this.categorieFormulaireWebService.getCategorieFormulaireAll().subscribe(res => {
      this.categories = [].concat(this.emptyCategorie).concat(res);
    });
  }

  submit() {
    this.buildFiltering();
    let rechercheModeleDto = this.initRechercheModele();
    this.onFiltering.emit(rechercheModeleDto);
  }

  //======= Gestion des filtres =======
  onRemove(filtre: FiltreItem) {

    if (filtre.field == 'modele') {
      this.filterForm.reset();
    }

    lodash.remove(this.filtres, (obj) => {
      return obj == filtre;
    });


    let rechercheModeleDto = this.initRechercheModele();
    this.onFiltering.emit(rechercheModeleDto);
  }

  private initRechercheModele(): RechercheModeleDto {
    let rechercheModeleDto = new RechercheModeleDto();

    this.filtres.forEach(f => {
      if (f.field == 'modele') {
        rechercheModeleDto.titre = f.value;
      }
      else {
        if (f.field == 'categorie'){
          if (rechercheModeleDto.categories == null) {
            rechercheModeleDto.categories = [];
          }
          rechercheModeleDto.categories.push(f.value);
        }
      }
    });

    return rechercheModeleDto;
  }

  buildFiltering() {
    let formValues = this.filterForm.value;

    lodash.remove(this.filtres, function(o) {
        return o.field == 'modele' || o.field == 'categorie';
    });

    if (formValues.modele){
      this.filtres.push(new FiltreItem('modele', formValues.modele, formValues.modele));
    }

    if (formValues.categorie) {
      this.filtres.push(new FiltreItem('categorie',formValues.categorie.libelle, formValues.categorie));
    }

    this.subscr.unsubscribe();

    this.filterForm.reset({
      modele: formValues.modele
    }, false);

    this.subscr = this.filterForm.valueChanges.debounceTime(500).subscribe(() => {
      this.submit();
    });

    this.logAuditFiltre();

  }

  logAuditFiltre() {
    let messageAudit = "Client " + this.userStore.getUser().login + " - Recherche modele – ";
    this.filtres.forEach((filtre, index) => {
      if (index > 0) {
        messageAudit += ", ";
      }
      messageAudit += filtre.field + "=" + filtre.value;
    });

    this.auditWebServiceClient.info({ message: messageAudit }).subscribe(() => {
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/dossier-bloques-modele/filtres/filtres.component.ts